/**
 * Created by cuppi on 2017/3/6.
 */
'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
const JDataUnify_1 = require("../unify/JDataUnify");
const JUrlList_1 = require("../unify/JUrlList");
const JNetworkRoot_1 = require("./JNetworkRoot");
/**
 * 个人中心接口
 * @memberOf module:network
 */
class JNetworkMine extends JNetworkRoot_1.default {
    /**
     * 我的订单
     * @private
     * @returns {*}
     */
    mineOrder() {
        return this.prefixPromise(JUrlList_1.mineUrl.userorders);
    }
    /**
     * 我的收藏(影院)
     * @returns {*}
     */
    mineFavoriteCinema() {
        return new Promise((resolve, reject) => {
            this.prefixPromise(JUrlList_1.mineUrl.jbzMineCinema).then(data => {
                resolve(JDataUnify_1.default('mineUrl.jbzMineCinema', data));
            }, error => {
                reject(error);
            });
        });
    }
    /**
     * 我的收藏
     * @private
     * @returns {*}
     */
    mineFavorite() {
        return this.prefixPromise(JUrlList_1.mineUrl.collectedcinemalist);
    }
    static mineOrder() {
        return this.instance().mineOrder();
    }
    static mineFavoriteCinema() {
        return this.instance().mineFavoriteCinema();
    }
    static mineFavorite() {
        return this.instance().mineFavorite();
    }
}
exports.default = JNetworkMine;
